(() => {
  if (window.FFHomeRuntimeSelector) {
    window.FFHomeRuntimeSelector.initialize();
    return;
  }
  const instances = new Map();
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  function attach(root) {
    if (instances.has(root) || !window.FFRuntimeEngine) return;
    const strings = JSON.parse(root.dataset.runtimeStrings);
    const controller = new AbortController();
    const eventOptions = {signal:controller.signal};
    const get = name => root.querySelector(`[data-runtime-${name}]`);
    const number = new Intl.NumberFormat(document.documentElement.lang || 'en',{maximumFractionDigits:2});
    const timeNumber = new Intl.NumberFormat(document.documentElement.lang || 'en',{maximumFractionDigits:1});
    const display = value => number.format(value);
    const form = get('form');
    const modelSelect = get('model-select');
    const running = get('running');
    const average = get('average');
    const category = get('device');
    let averageEdited = false;
    let selectedId = '';
    let resultTimer;
    const models = [...root.querySelectorAll('[data-runtime-model]')].map(node => ({
      id:node.dataset.modelId,
      name:node.dataset.model,
      capacityWh:Number(node.dataset.capacity),
      acRatedW:Number(node.dataset.rated),
      kind:node.dataset.kind,
      waveform:node.dataset.waveform,
      scenes:node.dataset.scenes.split(',').map(value=>value.trim()),
      primaryAvailable:node.dataset.primaryAvailable==='true',
      kitAvailable:node.dataset.kitAvailable==='true',
      primaryLink:node.dataset.primaryLink,
      kitLink:node.dataset.kitLink,
      primaryPrice:node.dataset.primaryPrice,
      kitPrice:node.dataset.kitPrice,
      node
    })).filter(model=>model.capacityWh>0&&model.acRatedW>0);
    const appliances = [...root.querySelectorAll('[data-runtime-appliance]')].map(node=>({
      key:node.dataset.key,
      label:node.dataset.label,
      aliases:node.dataset.aliases.split(',').map(value=>value.trim().toLocaleLowerCase()),
      watts:Number(node.dataset.watts),
      motor:node.dataset.motor==='true',
      pure:node.dataset.pure==='true',
      node
    }));
    function selectedModel() { return models.find(model=>model.id===selectedId); }
    function band(model) {
      if(model.acRatedW<=300) return 'small';
      if(model.acRatedW<=600) return 'medium';
      if(model.acRatedW<=1200) return 'large';
      return 'system';
    }
    function purchase(model) {
      const format = get('format').value;
      if(format==='kit') return {available:model.kitAvailable,link:model.kitLink,price:model.kitPrice,label:strings.kit};
      if(format==='station') return {available:model.primaryAvailable,link:model.primaryLink,price:model.primaryPrice,label:model.kind==='home_storage'?strings.home_storage:strings.station};
      if(model.primaryAvailable) return {available:true,link:model.primaryLink,price:model.primaryPrice,label:model.kind==='home_storage'?strings.home_storage:strings.station};
      return {available:model.kitAvailable,link:model.kitLink,price:model.kitPrice,label:strings.kit};
    }
    function filteredModels() {
      return models.filter(model=>{
        const scene = get('scene').value;
        const power = get('band').value;
        return purchase(model).available&&(scene==='all'||model.scenes.includes(scene))&&(power==='all'||band(model)===power);
      }).sort((a,b)=>a.acRatedW-b.acRatedW||a.capacityWh-b.capacityWh);
    }
    function refreshModels() {
      const candidates = filteredModels();
      const preferred = candidates.find(model=>model.id===selectedId)||candidates.find(model=>model.name===root.dataset.defaultModel)||candidates[0];
      modelSelect.replaceChildren();
      const groups = new Map();
      candidates.forEach(model=>{
        const groupKey = model.kind==='home_storage'?'home_storage':`${band(model)}_power`;
        let group = groups.get(groupKey);
        if(!group) {
          group = document.createElement('optgroup');
          group.label = strings[groupKey];
          groups.set(groupKey,group);
          modelSelect.append(group);
        }
        const option = document.createElement('option');
        option.value = model.id;
        option.textContent = `${model.name} · ${display(model.capacityWh)} Wh / ${display(model.acRatedW)} W${!model.primaryAvailable?' · '+strings.kit:''}`;
        group.append(option);
      });
      selectedId = preferred?.id||'';
      if(preferred) modelSelect.value=selectedId;
      else {
        const option=document.createElement('option');
        option.textContent=strings.empty_models;
        modelSelect.append(option);
      }
      modelSelect.disabled=!preferred;
      get('submit').disabled=!preferred;
      get('reset').hidden=!!preferred;
      get('count').textContent=preferred?strings.available_count.replace('{count}',String(candidates.length)):strings.empty_models;
      render();
    }
    function input() {
      return {
        averageW:average.value,
        runningW:running.value,
        startupW:get('startup').value,
        motor:get('motor').checked,
        targetHours:get('target').value,
        efficiencyPct:get('efficiency').value,
        reservePct:get('reserve').value,
        overheadW:get('extra').value
      };
    }
    function hours(value) {
      return `≈ ${timeNumber.format(value)} ${strings.hours}`;
    }
    function applyAppliance(appliance) {
      category.value=appliance.label;
      running.value=String(appliance.watts);
      average.value=String(appliance.watts);
      averageEdited=false;
      get('startup').value='';
      get('motor').checked=appliance.motor;
      get('pure').checked=appliance.pure;
      get('startup-field').hidden=!appliance.motor;
      render();
    }
    function safeWaveform(model) {
      return model.waveform==='pure'||(!get('pure').checked&&!get('motor').checked);
    }
    function renderMatches(model,data,result) {
      const holder=get('matches');
      holder.replaceChildren();
      let candidates=filteredModels().filter(candidate=>safeWaveform(candidate));
      const homePlan=model?.kind==='home_storage'||get('scene').value==='home_storage';
      candidates=candidates.filter(candidate=>homePlan?candidate.kind==='home_storage':candidate.kind==='portable');
      const matches=window.FFRuntimeEngine.recommend(candidates,data,3);
      get('match-count').textContent=String(matches.length);
      if(matches.length&&(result?.status==='overload'||result?.meetsTarget===false)) get('recommendations').open=true;
      matches.forEach(candidate=>{
        const item=document.createElement('article');
        item.className='ff-runtime__match';
        const button=document.createElement('button');
        button.type='button';
        button.dataset.runtimeMatch=candidate.id;
        button.setAttribute('aria-pressed',String(candidate.id===selectedId));
        const title=document.createElement('strong');
        title.textContent=candidate.name;
        const specs=document.createElement('span');
        specs.textContent=`${display(candidate.capacityWh)} Wh · ${display(candidate.acRatedW)} W`;
        const runtime=document.createElement('small');
        runtime.textContent=hours(candidate.calculation.runtimeHours);
        const choose=document.createElement('span');
        choose.className='ff-runtime__match-action';
        choose.textContent=candidate.id===selectedId?strings.selected:strings.select_match;
        button.append(title,specs,runtime,choose);
        const link=document.createElement('a');
        link.href=purchase(candidate).link;
        link.textContent=strings.view_product+' ↗';
        item.append(button,link);
        holder.append(item);
      });
      get('match-note').textContent=matches.length?'':result?.status==='startup_check'?strings.startup_matches:strings.no_matches;
    }
    function render() {
      clearTimeout(resultTimer);
      const model=selectedModel();
      models.forEach(candidate=>{candidate.node.hidden=candidate.id!==selectedId;});
      get('system-note').hidden=model?.kind!=='home_storage';
      const data=input();
      const result=model?window.FFRuntimeEngine.calculate(model,data):{valid:false,status:'invalid',runtimeHours:null,loadRatio:null,meetsTarget:null,reasonCodes:[]};
      let status=result.status;
      if(result.valid&&status==='within_rating'&&!safeWaveform(model)) status='waveform_check';
      if(model) {
        const sale=purchase(model);
        model.node.querySelector('[data-runtime-format-label]').textContent=sale.label;
        const link=model.node.querySelector('[data-runtime-product-link]');
        link.href=sale.link;
        link.textContent=(sale.label===strings.kit?strings.view_kit:strings.view_product)+' ↗';
        model.node.querySelector('[data-runtime-price]').textContent=sale.price;
      }
      get('hours').textContent=result.runtimeHours===null?'—':hours(result.runtimeHours);
      get('status').dataset.status=status;
      get('status').textContent=model?strings[status]:strings.empty_models;
      const hintKey={within_rating:'rating_hint',startup_check:'startup_hint',overload:'overload_hint',invalid:'invalid_hint',waveform_check:'waveform_hint'}[status];
      const notes=[model?strings[hintKey]:strings.empty_models];
      if(result.reasonCodes.includes('average_exceeds_running')) notes[0]=strings.average_error;
      if(result.runtimeHours!==null&&Number(data.averageW)<=20) notes.push(strings.low_load_note);
      get('result-note').textContent=notes.join(' ');
      if(status!=='within_rating'&&status!=='invalid'||model?.kind==='home_storage'||result.runtimeHours!==null&&Number(data.averageW)<=20) get('result-detail').open=true;
      const percentage=result.loadRatio===null?0:result.loadRatio*100;
      get('percent').textContent=result.loadRatio===null?'—':`${display(percentage)}%`;
      get('meter').setAttribute('aria-valuenow',String(Math.min(100,Math.max(0,percentage))));
      get('meter-fill').style.width=`${Math.min(100,Math.max(0,percentage))}%`;
      get('meter').setAttribute('aria-valuetext',`${display(percentage)}%`);
      get('power-caption').textContent=model&&result.valid?`${display(Number(data.runningW)+Number(data.overheadW))} W / ${display(model.acRatedW)} W`:'';
      const target=Number(data.targetHours);
      const targetVisible=data.targetHours.trim()!==''&&result.valid&&result.runtimeHours!==null;
      get('target-block').hidden=!targetVisible;
      if(targetVisible) {
        get('progress').value=Math.min(100,result.runtimeHours/target*100);
        get('target-value').textContent=`${display(target)} ${strings.hours}`;
        get('target-message').textContent=result.meetsTarget?strings.target_met:strings.target_short;
      }
      appliances.forEach(appliance=>{
        const check=model?window.FFRuntimeEngine.calculate(model,{...data,averageW:appliance.watts,runningW:appliance.watts,startupW:null,motor:appliance.motor,targetHours:null,overheadW:0}):null;
        const waveform=model?.waveform==='pure'||(!appliance.pure&&!appliance.motor);
        const state=!model?'unknown':check?.status==='overload'?'overload':appliance.motor?'startup':!waveform?'waveform':'within';
        const stateLabel={overload:strings.example_overload,startup:strings.example_startup,waveform:strings.example_waveform,within:strings.example_within,unknown:strings.estimate_pending}[state];
        appliance.node.hidden=false;
        appliance.node.dataset.powerState=state;
        appliance.node.querySelector('[data-runtime-device-state]').textContent=stateLabel;
        appliance.node.setAttribute('aria-label',`${appliance.label}, ${display(appliance.watts)} W, ${stateLabel}`);
        appliance.node.setAttribute('aria-pressed',String(category.value.toLocaleLowerCase()===appliance.label.toLocaleLowerCase()));
      });
      renderMatches(model,data,result);
    }
    form.addEventListener('input',event=>{
      if(event.target===category) return;
      if(event.target===average) averageEdited=true;
      if(event.target===running&&!averageEdited) average.value=running.value;
      if(event.target===get('motor')) {
        get('startup-field').hidden=!get('motor').checked;
        if(!get('motor').checked) get('startup').value='';
      }
      clearTimeout(resultTimer);
      resultTimer=setTimeout(render,220);
    },eventOptions);
    form.addEventListener('change',event=>{
      if(event.target===category) {
        const value=category.value.trim().toLocaleLowerCase();
        const appliance=appliances.find(item=>item.label.toLocaleLowerCase()===value||item.aliases.includes(value));
        if(appliance) applyAppliance(appliance);
        else {
          running.value='';
          average.value='';
          averageEdited=false;
          get('startup').value='';
          get('motor').checked=false;
          get('pure').checked=true;
          get('startup-field').hidden=true;
          render();
        }
        return;
      }
      if(['scene','band','format'].includes(event.target.name)) refreshModels();
      else if(event.target===modelSelect) {selectedId=modelSelect.value;render();}
      else render();
    },eventOptions);
    form.addEventListener('submit',event=>{
      event.preventDefault();
      render();
      if(!form.reportValidity()) return;
      if(innerWidth<=959) get('result-panel').scrollIntoView({behavior:reducedMotion.matches?'instant':'smooth',block:'start'});
    },eventOptions);
    root.addEventListener('click',event=>{
      const example=event.target.closest('[data-runtime-appliance]');
      if(example) applyAppliance(appliances.find(item=>item.key===example.dataset.key));
      const choice=event.target.closest('[data-runtime-match]');
      if(choice) {
        selectedId=choice.dataset.runtimeMatch;
        modelSelect.value=selectedId;
        render();
        if(innerWidth<=959) get('result-panel').scrollIntoView({behavior:reducedMotion.matches?'instant':'smooth',block:'start'});
      }
      if(event.target.closest('[data-runtime-reset]')) {
        get('scene').value='all';
        get('band').value='all';
        get('format').value='all';
        refreshModels();
      }
    },eventOptions);
    root.addEventListener('shopify:block:select',event=>{
      const card=event.target.closest('[data-runtime-model]');
      if(!card) return;
      get('scene').value='all';get('band').value='all';get('format').value='all';
      selectedId=card.dataset.modelId;
      refreshModels();
    },eventOptions);
    instances.set(root,()=>{controller.abort();clearTimeout(resultTimer);});
    modelSelect.disabled=false;
    get('submit').disabled=false;
    const initial=appliances.find(appliance=>appliance.node.dataset.key==='laptop')||appliances.find(appliance=>appliance.node.dataset.motor==='false')||appliances[0];
    if(initial) applyAppliance(initial);
    refreshModels();
    root.dataset.runtimeReady='true';
  }
  function initialize(scope=document) {
    const roots=[...scope.querySelectorAll('[data-ff-runtime-selector]')];
    if(scope.matches?.('[data-ff-runtime-selector]')) roots.unshift(scope);
    roots.forEach(attach);
  }
  window.FFHomeRuntimeSelector={initialize};
  document.addEventListener('shopify:section:load',event=>initialize(event.target));
  document.addEventListener('shopify:section:unload',event=>{
    instances.forEach((cleanup,root)=>{
      if(!event.target.contains(root)) return;
      cleanup();instances.delete(root);
    });
  });
  initialize();
})();
